/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from 'react';
import Model from '@tripian/model';
import PreLoading from '../base/PreLoading/PreLoading';
import classes from './SearchThisArea.scss';
import { ChevronDown, ChevronUp } from '../base/Svg/Icons';

interface ISearchThisArea {
  categoryGroups?: Model.PoiCategoryGroup[];
  searchPoi: (categoryIds: number[]) => Promise<Model.Poi[]>;
  searchPoiCallBack: (pois: Model.Poi[]) => void;
  clearPois: () => void;
  hide: boolean;
  t: (value: Model.TranslationKey) => string;
  toggleStorages: (value: boolean) => void;
}

const SearchThisArea: React.FC<ISearchThisArea> = ({ hide, categoryGroups, searchPoi, searchPoiCallBack, clearPois, t, toggleStorages }) => {
  const [showCategoryList, setShowCategoryList] = useState(false);
  const [showClearButton, setShowClearButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clearButtonText, setClearButtonText] = useState<string>();
  const [expandedGroups, setExpandedGroups] = useState<string[]>([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState<number[]>([]);
  const [pendingPois, setPendingPois] = useState<Model.Poi[]>([]);
  const [luggageStorageSelected, setLuggageStorageSelected] = useState(false);
  const wrapperRef = useRef<HTMLUListElement>(null);

  const toggleGroup = (groupName: string) => {
    setExpandedGroups((prev) => (prev.includes(groupName) ? prev.filter((name) => name !== groupName) : [...prev, groupName]));
  };

  const updateClearButton = (poisCount?: number, luggageSelected?: boolean) => {
    if ((poisCount && poisCount > 0) || luggageSelected) {
      setShowClearButton(true);
      if (poisCount !== undefined) {
        setClearButtonText(`${t('trips.myTrips.itinerary.searchThisArea.clear')} (${poisCount})`);
      } else if (luggageSelected) {
        setClearButtonText(`${t('trips.myTrips.itinerary.searchThisArea.clear')}`);
      }
    } else {
      setShowClearButton(false);
      setClearButtonText('');
    }
  };

  const updatePois = (newCategoryIds: number[]) => {
    setLoading(true);
    searchPoi(newCategoryIds).then((pois: Model.Poi[]) => {
      setPendingPois(pois);
      setLoading(false);
      updateClearButton(pois.length, luggageStorageSelected);
    });
  };

  const handleCategoryChange = (categoryId: number) => {
    setSelectedCategoryIds((prevSelected) => {
      const newSelected = prevSelected.includes(categoryId) ? prevSelected.filter((id) => id !== categoryId) : [...prevSelected, categoryId];

      if (newSelected.length > 0) {
        updatePois(newSelected);
      } else {
        clearPois();
        updateClearButton(undefined, luggageStorageSelected);
      }
      return newSelected;
    });
  };

  const handleGroupChange = (group: Model.PoiCategoryGroup) => {
    const groupCategoryIds = group.categories.map((cat) => cat.id);

    setSelectedCategoryIds((prevSelected) => {
      const allSelected = groupCategoryIds.every((id) => prevSelected.includes(id));

      const newSelected = allSelected
        ? prevSelected.filter((id) => !groupCategoryIds.includes(id)) // Eğer zaten seçiliyse kaldır
        : [...new Set([...prevSelected, ...groupCategoryIds])]; // Seçili değilse ekle

      if (newSelected.length > 0) {
        updatePois(newSelected);
      } else {
        clearPois();
        updateClearButton(undefined, luggageStorageSelected);
      }

      return newSelected;
    });
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node) && !(event.target as HTMLElement).closest(`.${classes.button}`)) {
      setShowCategoryList(false);
    }
  };

  useEffect(() => {
    if (pendingPois.length) {
      searchPoiCallBack(pendingPois);
      setPendingPois([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingPois]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (loading) {
    return <PreLoading size="small" />;
  }

  return (
    <div style={hide && !showClearButton ? { display: 'none' } : {}}>
      {showClearButton ? (
        <div
          className={classes.button}
          onClick={() => {
            clearPois();
            setShowClearButton(false);
            setSelectedCategoryIds([]);
            setLuggageStorageSelected(false);
            toggleStorages(false);
          }}
          onKeyDown={() => {}}
          tabIndex={0}
          role="button"
        >
          {clearButtonText}
        </div>
      ) : (
        <div className={classes.button} onClick={() => setShowCategoryList(!showCategoryList)} onKeyDown={() => {}} tabIndex={0} role="button">
          {showCategoryList ? t('trips.myTrips.itinerary.searchThisArea.cancel') : t('trips.myTrips.itinerary.searchThisArea.title')}
        </div>
      )}

      {showCategoryList && categoryGroups && (
        <ul className={classes.categoryList} ref={wrapperRef}>
          {categoryGroups.map((group) => {
            const hasSubCategories = group.categories.some(
              (cat) => cat.name !== group.name
            );
            return (
              <li key={group.name} className={classes.categoryListGroup}>
                <button type="button" className={classes.categoryListGroupButton} onClick={() => toggleGroup(group.name)}>
                  <div className={classes.categoryListGroupButtonLabel}>
                    <input
                      className={classes.categoryListCheckboxInput}
                      type="checkbox"
                      checked={group.categories.every((cat) => selectedCategoryIds.includes(cat.id))}
                      onChange={() => handleGroupChange(group)}
                    />
                    <span className={classes.categoryListCheckboxText}>{group.name}</span>
                  </div>
                  {/* 🔽 OK SADECE ALT KATEGORİ VARSA */}
                  {hasSubCategories &&
                    (expandedGroups.includes(group.name) ? (
                      <ChevronUp className={classes.categoryListGroupIcon} />
                    ) : (
                      <ChevronDown className={classes.categoryListGroupIcon} />
                    ))}
                </button>
                {expandedGroups.includes(group.name) && (
                  <div className={classes.categoryListGroupContent}>
                    {group.categories.map((category) => (
                      <label key={category.id} className={classes.categoryListCheckboxLabel}
                             style={{ display: group.name === category.name ? "none" : "flex" }} >
                        <input type="checkbox" checked={selectedCategoryIds.includes(category.id)} onChange={() => handleCategoryChange(category.id)} />
                        <span className={classes.categoryListCheckboxText}>{category.name}</span>
                      </label>
                    ))}
                  </div>
                )}
              </li>
            )
          })}
          <li key="radicalStorage" className={classes.categoryListGroup}>
            <label className={classes.categoryListGroupButton}>
              <div className={classes.categoryListGroupButtonLabel}>
                <input
                  className={classes.categoryListCheckboxInput}
                  type="checkbox"
                  checked={luggageStorageSelected}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setLuggageStorageSelected(checked);
                    toggleStorages(checked);
                    updateClearButton(undefined, checked);
                    setShowCategoryList(false);
                  }}
                />
                <span className={classes.categoryListCheckboxText}>Luggage Storage</span>
              </div>
            </label>
          </li>
        </ul>
      )}
    </div>
  );
};

export default SearchThisArea;
